/**
 * 栄養成分情報登録用VOクラス
 */
export class GoodsNutrientRegistModel {
  /**
* Ｐコード
*/
  public pCode: string = <string>'';

  /**
   * アイテムコードコード
   */
  public itemCode: string = <string>'';

  /**
   * 分析連番
   */
  public analysisSeqNo: string = <string>'';

  /**
   * 分析単位
   */
  public analysisUnit: string = <string>'';

  /**
   * 栄養成分備考
   */
  public nutrientNote: string = <string>'';

  /**
   * 栄養成分リスト
   */
  public nutrientComponentList: Array<any>;
}
